export const environment = {
    production: true,
    apiGatewayUrl: 'https://apigateway.agilitypr-preprod.com/api/v1',
    websocketUrl: 'wss://apigateway.agilitypr-preprod.com:443/ws',
    newsroomExternalSiteBaseUrl: 'http://newsroom-preprod.agilitypr.internal:8080',
    sharedReportsUrl: 'http://reports.agilitypr-preprod.com',
    journodexAppUrl: 'https://journodex.agilitypr-preprod.com',
    accesswireEditingDelay: 75,
    mapboxToken: 'pk.eyJ1IjoiYWdpbGl0eW1hcHMiLCJhIjoiY2trb2lzZ2ZxMmR2cTJ1cTkxemJjYm13NSJ9.Ksk9gy7RoEOFMcJrVBO3Eg',
    intercomID: 'ceqhzmoo',
    googleTagId: 'G-HWRVYYP4N0',
    pendoApiKey: 'a1c9b5fd-6c7f-4e5d-4c14-1cf31a447f1c',
    pendoPrefix: 'preprod-',
    deployUrl: 'assets/',
    thirdPartyEnabledAccounts: [76636, 85392],
    bmieUrl: 'https://briefings.agilitypr-preprod.com/',
    sessionTimeoutInMinutes: 60,
    debugTopicAgenticWorkflowAccountIds: [1210],
    contentLibraryUrl: 'https://public-preprod.agilitypr.media/'
};
